import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import _ from 'lodash';
import { POLICY_DOC_TYPES } from '../constants/policy-doc';

const mappings = {
  GRACE_LETTER: 'Warning: Policy in Grace Period',
  LAPSE_LETTER: 'Cancellation notice',
  NOT_TAKEN_LETTER: 'Policy not taken',
  FREE_LOOK_CANCEL_LETTER: 'Free look canceled',
  ACH_RETURN_LETTER: 'ACH Return notice',
  ADDRESS_CHANGE_LETTER: 'Address Change notice',
};

@supertypeClass({ toClient: true, toServer: true })
export class PolicyInfoDoc extends Supertype {
  @property()
  policyNumber: string;

  @property({ toClient: false })
  docID: string;

  @property()
  docDate: Date;

  @property()
  docName: string;

  @property()
  docType: string;

  @property()
  fileName: string;

  @property()
  type: string;

  constructor() {
    super();
  }

  static new(document) {
    return new PolicyInfoDoc().init(document);
  }

  init(document) {
    this.policyNumber = document.policyNumber;
    this.docID = document.documentId;
    this.docDate = new Date(document.documentDate);

    const docInfo = document.documentInfo;

    if (docInfo) {
      this.docName = docInfo.name;
      this.docType = mappings[docInfo.value];
      this.fileName = this.docType + '_' + this.policyNumber + '.pdf';
    } else {
      this.docName = 'Policy';
      this.docType = 'Policy Document';
      this.fileName = `${this.policyNumber}_Policy_Document.pdf`;
    }

    this.type = POLICY_DOC_TYPES.pdf;

    return this;
  }

  clientInit() {}

  reset() {}
}
